<template>
    <template v-if="menus?.footer?.length">
        <ul class="main-footer-menu-list mt-0 mb-0 inline-block mx-auto text-center">
            <li v-for="(item, index) in menus.footer" :key="index">
                <template v-if="item.url">
                    <router-link v-if="item.type == 'internal'" :to="item.url" :target="item.is_new_tab ? '_blank': ''" class="text-sub-color dark:text-gray-300">
                        {{item.name}}              
                    </router-link>
                    <a v-else :href="item.url" :target="item.is_new_tab ? '_blank': ''" class="text-sub-color dark:text-gray-300">
                        {{item.name}}
                    </a>
                </template>
                <template v-else>
                    {{item.name}}
                </template>
            </li>
        </ul>
    </template>
    <template v-else>
        <div class="h-8 flex justify-center items-center">
            <div class="p-skeleton w-40 h-8"></div>
        </div>
    </template>
</template>

<script>
import { mapState } from 'pinia';
import { useAppStore } from '../../store/app';
export default {
    computed: {
        ...mapState(useAppStore, ['menus'])
    }
}
</script>
